export const Burger = ({ color = "#0E0E0E" }: { color?: string }) => {
	return (
		<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
			<line
				x1="5.75"
				y1="11.25"
				x2="18.25"
				y2="11.25"
				stroke={color}
				strokeWidth="1.5"
				strokeLinecap="round"
			/>
			<line
				x1="5.75"
				y1="16.25"
				x2="18.25"
				y2="16.25"
				stroke={color}
				strokeWidth="1.5"
				strokeLinecap="round"
			/>
			<line
				x1="5.75"
				y1="6.25"
				x2="18.25"
				y2="6.25"
				stroke={color}
				strokeWidth="1.5"
				strokeLinecap="round"
			/>
		</svg>
	);
};
